import { render, staticRenderFns } from "./doctorReport.vue?vue&type=template&id=0ada2b2c&scoped=true&"
import script from "./doctorReport.vue?vue&type=script&lang=js&"
export * from "./doctorReport.vue?vue&type=script&lang=js&"
import style0 from "./doctorReport.vue?vue&type=style&index=0&id=0ada2b2c&scoped=true&lang=css&"
import style1 from "./doctorReport.vue?vue&type=style&index=1&id=0ada2b2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ada2b2c",
  null
  
)

component.options.__file = "doctorReport.vue"
export default component.exports